import * as React from 'react';
import { Button, NavItem, NavLink } from 'reactstrap';
import { NavLink as RRNavLink } from 'react-router-dom';
import { RoutesModules } from 'src/modules/Routing/types';

export interface INavigationLinkProps {
  counter?: number;
  filterPath?: string;
  handleClick?: (event?: any) => void;
  isActive?: boolean;
  navTitle: RoutesModules | string;
  routePath: string;
  isSidebar?: boolean;
}

const NavigationLink = (props: INavigationLinkProps) => {
  const Wrapper = ({ isSidebar, children }) => {
    return isSidebar ?
      <div className="sidebar-link">
        {children}
      </div> :
      <NavItem>
        {children}
      </NavItem>
  }
  return (
    <Wrapper isSidebar={props.isSidebar}>
      <NavLinkComponent {...props} />
    </Wrapper>
  )
}

interface INavLinkProps {
  exact: boolean;
  isActive?: () => boolean;
  onClick?: (event?: any) => void;
  tag: any;
  to: string;
}

const NavLinkComponent = ({ counter = 0, filterPath, isActive, isSidebar, handleClick, navTitle, routePath }: INavigationLinkProps) => {
  const props: INavLinkProps = {
    exact: true,
    ...isActive ? { isActive: () => isActive } : {},
    onClick: handleClick || (() => null),
    tag: RRNavLink,
    to: `${routePath.replace('/:caseId', '').replace('/:closed', '/closed')}${filterPath || ''}`,
  }
  return (
    <NavLink {...props} >
      {isSidebar ? <h5>{navTitle}</h5> : navTitle}
      {
        counter > 0 &&
        <Button className="btn-gray btn-notification-counter" >
          {counter}
        </Button>
      }
    </NavLink>
  )
}

export default React.memo(NavigationLink);
